import { BreadCrumbItem, SearchResult } from '../interfaces/search.interface';
import { Catalog } from '../../../common/constants/catalog';
import { DocumentType } from '../../product-card/interfaces/product-card.interface';
import { ProductCardData } from '../../product-card/product-card-display';
import { getImage, getProductLabelAndUrl, isPublished } from '../utils/search-results.util';
import { isSearchPage } from '../../../common/utils/util';

/**
 * Maps search results to product card data.
 *
 * @param results
 * @param catalog
 * @param selectedCatalog
 * @param store
 * @param showUrlsAsSearchPage
 */
export function mapProductCardData(
  results: Array<SearchResult>,
  catalog: string,
  selectedCatalog?: string,
  store?: string,
  showUrlsAsSearchPage = false
): Array<ProductCardData> {
  return results.map((result) => {
    const program: BreadCrumbItem|undefined = getProgramFromProductBreadcrumbs(result.document.breadCrumbItems);

    return {
      kind: 'ProductCardData',
      title: result.document.title,
      titleType: result.document.titleType,
      image: getImage(result.document),
      url: getProductLabelAndUrl(result.document, catalog, store, showUrlsAsSearchPage).url,
      copyRightYear: result.document.copyrightYear ? result.document.copyrightYear.toString() : '',
      businessUnit: catalog,
      ...(result.document.businessUnit && { productBusinessUnit: result.document.businessUnit }),
      store: store,
      mhid: result.document.mhid || result.document.isbn,
      isbn: result.document.mhid || result.document.isbn,
      isbn13: result.document.isbn13,
      netPrice: result.document.price,
      description: result.document.description,
      gradeLevels: result.document.gradeLevels,
      contributors: result.document.contributors,
      instructorOnly: result.document.instructorOnly,
      isPublished: isPublished(result.document.publicationDate),
      edition: result.document.EDITION || result.document.edition,
      publicationDate: result.document.publicationDate,
      documentType: result.document.documentType,
      type: result.document.type,
      programId: result.document?.documentType === DocumentType.programs
        ? result.document.id
        : program?.value,
      programLabel: program ? program.label : '',
      quantity: 1,
      catalogLabel:
        isSearchPage() && selectedCatalog === Catalog.seg
          ? result.document?.documentType === DocumentType.programs
            ? 'Program'
            : 'Product'
          : '',
      partsOf: program,
      optimizedUniqueTitle: result.document.optimizedUniqueTitle,
      id: result.document.id,
      programSourceId: result.document.id,
      programSourceName: result.document.optimizedUniqueTitle,
      isEvergreen: result.document.everGreenProduct || false,
      relatedProducts: result.document.RELATED_PRODUCTS,
    }
  });
}

function getProgramFromProductBreadcrumbs(breadCrumbItems: BreadCrumbItem[] | undefined) {
  if (!breadCrumbItems) return;

  return breadCrumbItems.find(item => !item.seoLabel.startsWith('ca.'));
}
